<template>
  <group v-if="customized && customized.store_config">
    <cell title="当前所在门店" is-link>
      <p @click="handlerLogout">{{ customized.store_config.store_name }}</p>
    </cell>
  </group>
</template>
<script>
import { Cell, Group } from '@lx-frontend/cvux'
import cache from '@/common/cache'

export default {
  components: {
    Cell,
    Group
  },
  methods: {
    // 退出登录
    async handlerLogout () {
      // 用户只关联一家店时,不能登出
      if (!this.storesConfig || (this.storesConfig && this.storesConfig.length < 2)) return

      const res = await this.$rest.auth.authLogout()

      if (res.code !== 0) {
        this.showToast(res.message)
        return
      }

      cache.clearSessionData('hasLogin')
      cache.clearSessionData('access_token')
    }
  }
}
</script>
